export default "__VITE_ASSET__imRMF49L__"